import {
  IAppAction,
  addAppAction,
  addAppFailureAction,
  addAppSuccessAction,
  getAllSuccessAction,
  getAllFailureAction,
  deleteAppSuccessAction,
  deleteAppFailureAction,
} from "../actions/app.action";
import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../store";
import {
  searchAction,
  searchFailureAction,
  searchSuccessAction,
} from "../actions/app.action";
import { addApp, addAppManul, getApps, searchApp } from "../../services/app";
import { isArray } from "lodash";
import { IAppInfo, IAppInfoDTO, IAppManualDTO } from "../../interfaces/dto/app.dto";
import { IAddApp } from "../../interfaces/app";
import { AppType } from "../../enum/app";
import { deleteApp } from "../../services/app";

export const searchAppThunk =
  (search: string, type: AppType, searchMode: string, gl: string) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAppAction>,
    getState: () => IRootState,
  ): Promise<Array<IAppInfo> | string> => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(searchAction());

      const response = await searchApp(search, searchMode, type, auth.token, gl);

      if (isArray(response)) {
        dispatch(searchSuccessAction(response));

        return response;
      } else {
        dispatch(searchFailureAction(response.error));

        return response.error;
      }
    } else {
      return "No session";
    }
  };

  export const addAppManulThunk =
  (payload: IAppManualDTO, appType: AppType) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAppAction>,
    getState: () => IRootState,
  ): Promise<boolean> => {
    const { auth } = getState();

    if (auth.token && auth.userId) {
      dispatch(addAppAction());

      const response = await addAppManul(payload, appType, auth.userId, auth.token);

      if (response.error) {
        dispatch(addAppFailureAction(response.error));

        return false;
      } else {
        dispatch(addAppSuccessAction(response));
        dispatch(getAppsThunk());
        return true;
      }
    } else {
      return false;
    }
  };

export const addAppThunk =
  (payload: IAddApp) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAppAction>,
    getState: () => IRootState,
  ): Promise<boolean> => {
    const { auth } = getState();

    if (auth.token && auth.userId) {
      dispatch(addAppAction());

      const response = await addApp(payload, auth.userId, auth.token);

      if (response.error) {
        dispatch(addAppFailureAction(response.error));

        return false;
      } else {
        dispatch(addAppSuccessAction(response));
        dispatch(getAppsThunk());
        return true;
      }
    } else {
      return false;
    }
  };

export const getAppsThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAppAction>,
    getState: () => IRootState,
  ): Promise<IAppInfoDTO | undefined> => {
    const { auth } = getState();

    if (auth.token && auth.userId) {
      const response = await getApps(auth.userId, auth.token);

      if (response.error) {
        dispatch(getAllFailureAction(response.error));
        return undefined;
      } else {
        dispatch(getAllSuccessAction(response.data));
        return response;
      }
    }
  };

export const deleteAppThunk =
  (id: string) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAppAction>,
    getState: () => IRootState,
  ): Promise<boolean> => {
    const { auth } = getState();

    if (auth.token && auth.userId) {
      const response = await deleteApp(auth.userId, id, auth.token);

      if (response.error) {
        dispatch(deleteAppFailureAction(response.error));
        return true;
      } else {
        dispatch(deleteAppSuccessAction("Deleted"));
        dispatch(getAppsThunk());
      }
    }

    return false;
  };
